// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "xlsx" + "." + "aa31e95c" + ".js";
};